import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { of } from 'rxjs';
import { AuthSelectors } from '../store/auth/auth.selectors';
import { UserType } from '../../domain/user/model/user-type';
import { ROUTES } from '../common/routes';

/**
 * Guard factory that checks if the current user's userType is in the allowed list.
 * Redirects to ROUTES.AUTH.UNAUTHORIZED if not authorized.
 *
 * @param allowedUserTypes - One or more UserType values that may access the route.
 * @returns A CanActivateFn that allows or denies route access.
 */
export function isAuthorizedGuard(
  ...allowedUserTypes: UserType[]
): CanActivateFn {
  return () => {
    const router = inject(Router);
    const store = inject(Store);

    const account = store.selectSnapshot(AuthSelectors.getCurrentLogged);
    const allowed =
      account != null && allowedUserTypes.includes(account.userType);

    return allowed ? of(true) : of(router.parseUrl(ROUTES.AUTH.UNAUTHORIZED));
  };
}
